
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '货币名称',
value: this.$route.params.Item.PC_Name
}, {
label: '货币代码说明',
value: this.$route.params.Item.PC_Remark
}, {
label: '货币符号',
value: this.$route.params.Item.PC_Char
}]
}
}



// WEBPACK FOOTER //
// ./src/components/CurrencyDetail.vue